/**
 * NOTE ABOUT THIS SCRIPT
 * -----------------------
 * The theme’s variant logic has been heavily modified, breaking the original functionality.
 * Attempts to unwind or re-integrate the original logic break new behaviors such as
 * availability handling and ETA/back-in-stock notifications.
 *
 * To avoid causing further regressions, simplified variant
 * availability styling is implemented here in a standalone script.
 */

document.addEventListener('DOMContentLoaded', () => {

  const updateVariantAvailability = () => {
    const fieldsets = document.querySelectorAll('.variant-input-wrap');
    const selected = {};

    fieldsets.forEach(fs => {
      const checked = fs.querySelector('input[type="radio"]:checked');
      if (!checked) return;
      selected[fs.dataset.index] = checked.value;
    });

    fieldsets.forEach(fs => {
      const optionIndex = fs.dataset.index;
      const optionHandle = fs.dataset.handle;
      const variantInputs = fs.querySelectorAll('.variant-input');

      variantInputs.forEach(input => {
        const combosStr = input.dataset.variantCombinations;
        const label = input.querySelector('.variant__button-label');
        const radio = input.querySelector('input[type="radio"]');

        if (!combosStr || !label) return;

        const combos = combosStr
          .split('@@')
          .filter(Boolean)
          .map(c => {
            const [opt1, opt2, opt3, avail] = c.split('||');
            return { opt1, opt2, opt3, available: avail === 'true' };
          });

        const isAvailable = combos.some(({ opt1, opt2, opt3, available }) => {
          if (!available) return false;

          if (optionIndex !== 'option1' && selected.option1 && opt1 !== selected.option1) return false;
          if (optionIndex !== 'option2' && selected.option2 && opt2 !== selected.option2) return false;
          if (optionIndex !== 'option3' && selected.option3 && opt3 !== selected.option3) return false;

          return true;
        });

        // Wheel options have variant combinations that will never exist
        // (e.g., a front wheel will never have a freehub option).
        // For better UX, show all wheel options as available and allow the user
        // to click any wheel option.
        if (optionHandle === 'wheel') {
           label.classList.remove('disabled');
           if (radio) radio.classList.remove('disabled');
        } else {
          label.classList.toggle('disabled', !isAvailable);
          if (radio) radio.classList.toggle('disabled', !isAvailable);
        }
      });
    });
  };

  updateVariantAvailability();

  document.addEventListener('change', e => {
    if (e.target.matches('[data-variant-input]')) updateVariantAvailability();
  });
});
